(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["card-grid-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('card-grid-slider')) {
    class CardGridSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-cgs-track]');
        this.prev = this.querySelector('[data-cgs-prev]');
        this.next = this.querySelector('[data-cgs-next]');
        this.dotsWrap = this.querySelector('[data-cgs-dots]');
        if (!this.track) return;

        this.update = this.update.bind(this);

        this.prev?.addEventListener('click', () => this.step(-1));
        this.next?.addEventListener('click', () => this.step(1));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.raf);
          this.raf = requestAnimationFrame(() => this.syncState());
        }, { passive: true });
        this.track.addEventListener('keydown', (e) => {
          if (e.target !== this.track) return; // don't hijack arrows inside card content
          const fwd = this.isRTL ? 'ArrowLeft' : 'ArrowRight';
          const back = this.isRTL ? 'ArrowRight' : 'ArrowLeft';
          if (e.key === fwd) { e.preventDefault(); this.step(1); }
          if (e.key === back) { e.preventDefault(); this.step(-1); }
        });

        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);

        // Cards added / removed / reordered in the theme editor
        this.mutationObserver = new MutationObserver(this.update);
        this.mutationObserver.observe(this.track, { childList: true });

        // Theme editor: bring the selected card (or a block inside it) into view
        this.onBlockSelect = (e) => {
          const card = this.cards.find((c) => c.contains(e.target));
          if (card) this.scrollToCard(card);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      get cards() {
        return Array.from(this.track.children).filter(
          (el) => el.nodeType === 1 && !['SCRIPT', 'STYLE', 'TEMPLATE'].includes(el.tagName)
        );
      }

      get isSlider() {
        return getComputedStyle(this.track).display === 'flex';
      }

      get isRTL() {
        return getComputedStyle(this.track).direction === 'rtl';
      }

      get progress() {
        return Math.abs(this.track.scrollLeft);
      }

      get maxScroll() {
        return this.track.scrollWidth - this.track.clientWidth;
      }

      cardOffset(card) {
        const t = this.track.getBoundingClientRect();
        const c = card.getBoundingClientRect();
        const fromStart = this.isRTL ? t.right - c.right : c.left - t.left;
        return fromStart + this.progress;
      }

      scrollToOffset(offset) {
        const clamped = Math.max(0, Math.min(offset, this.maxScroll));
        this.track.scrollTo({ left: this.isRTL ? -clamped : clamped });
      }

      step(dir) {
        const first = this.cards[0];
        if (!first) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.scrollToOffset(this.progress + (first.getBoundingClientRect().width + gap) * dir);
      }

      scrollToCard(card) {
        if (!this.isSlider) return;
        this.scrollToOffset(this.cardOffset(card));
      }

      pageCount() {
        const max = this.maxScroll;
        let count = 0;
        for (const card of this.cards) {
          count++;
          if (this.cardOffset(card) >= max - 2) break;
        }
        return Math.max(count, 1);
      }

      activeIndex(pages) {
        const x = this.progress;
        if (x >= this.maxScroll - 2) return pages - 1;
        let best = 0, bestDist = Infinity;
        this.cards.forEach((card, i) => {
          const d = Math.abs(this.cardOffset(card) - x);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return Math.min(best, pages - 1);
      }

      buildDots() {
        if (!this.dotsWrap) return;
        const pages = this.isSlider ? this.pageCount() : 0;
        const wanted = pages < 2 ? 0 : pages;
        if (this.dotsWrap.childElementCount === wanted) return;
        this.dotsWrap.replaceChildren();
        for (let i = 0; i < wanted; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'cgs__dot';
          dot.tabIndex = -1;
          dot.addEventListener('click', () => this.scrollToCard(this.cards[i]));
          this.dotsWrap.appendChild(dot);
        }
      }

      syncState() {
        const x = this.progress;
        if (this.prev) this.prev.disabled = x <= 2;
        if (this.next) this.next.disabled = x >= this.maxScroll - 2;

        const dots = this.dotsWrap?.querySelectorAll('.cgs__dot');
        if (!dots?.length) return;
        const idx = this.activeIndex(dots.length);
        dots.forEach((dot, i) => dot.setAttribute('aria-current', i === idx ? 'true' : 'false'));
      }

      update() {
        this.buildDots();
        this.syncState();
      }
    }

    customElements.define('card-grid-slider', CardGridSlider);
  }
  } catch(e) { console.error(e); }
})();

})();
